import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

interface IExpandButtonProps {
  expanded: boolean;
}

export const ExpandButton = styled.button<IExpandButtonProps>(
  props => css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    min-height: 100%;
    transition: background-color ${layout.animations.buttonTransition};
    background-color: transparent;
    padding: ${layout.measurements.spacingTiny};

    ${props.expanded
      ? css`
          border-radius: 8px 0 0 0;
        `
      : css`
          border-radius: 8px 0 0 8px;
        `}

    svg path {
      fill: ${props.theme.icons.secondary};
    }

    &:hover {
      background-color: #f7f7f7;
    }
  `
);
